// extracted by mini-css-extract-plugin
export default {"card":"Stations_card__bpopg"};